import { Directive } from '@angular/core';
import {CustomValidationService} from '../services/custom-validation.service';
import {AbstractControl, NG_VALIDATORS} from '@angular/forms';

@Directive({
  selector: '[positiveNumber]',
  providers: [{ provide: NG_VALIDATORS, useExisting: PositiveNumberPatternDirective, multi: true }]
})
export class PositiveNumberPatternDirective {

  constructor(private customValidator: CustomValidationService) { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    return this.customValidator.positiveNumberPatternValidator()(control);
  }

}